module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAPtJREFUOBHtVMENwjAMbBBvePHuDl2JDboHbNCV2AUGoJxDHLnmkrQfxINIJonPZ13MqV33X2kCwU5inucj7mfEwebT+YF9CiHcCdaBOwC7MUzAEVFbIyUiCdJgsZ294MyU2pIWnmt9Y3lubbXwzN3n0/swpTtTJk0Vd7TGFXPqEadGGYX9jL3iJ1gSeYHAnBLVlxwiZN9YZu7nLva7SDFZV5KLKd/kQzGq2LyFXMrTxkxxyQmlfGzsR8EUqxOswm0OwR/VI77jivgu/BTcoXD9BTXFwDZ9R9a4QlXZGWvO7gvcN2auUHLVBSha4GtcoY2ZOxSrz1irfnp/AW57kO0yvcXbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_ValighJustify_normal.png
// module id = 320
// module chunks = 0